import house1 from './house1.png'
import house2 from './house2.png'
import house3 from './house3.png'
import house4 from './house4.png'
import house5 from './house5.jpeg'
import house6 from './house6.jpeg'
import house7 from './house7.jpeg'
import house8 from './house8.jpeg'
import house9 from './house9.jpeg'
import house10 from './house10.jpeg'

export const images = {
    house1,
    house2,
    house3,
    house4,
    house5,
    house6,
    house7,
    house8,
    house9,
    house10
}